@import "./dashboard-carousel-item/dashboard-carousel-item.scss";
@import "../../dashboard-item-header/dashboard-item-header.scss";

.dashboard-view-carousel {
  display: block;
  position: relative;
}
